import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { ContactForContract } from "../Entities/ContactForContract/ContactForContract";
import { ContactForContractInterface } from "../Entities/ContactForContract/ContactForContractInterface";
import TypeContainer from "../Entities/ContactForContract/Type/TypeContainer";
//import Store from "../../Store/Store";

class ContactForContractFactory extends Factory implements FactoryInterface {

  public create(data: any): ContactForContractInterface {
    return new ContactForContract({
      id: data.id,
      contactId: data.contactId,
      description: data.contractPartyDescription,
      contactForContractTypeId: data.contactForContractTypeId,
      type: TypeContainer.pickFromId(data.contactForContractTypeId),
      removed: data.removed
    });
  }

  public reinitialize(data: any): ContactForContractInterface {
    return new ContactForContract({
      ...data
    });
  }
}

export default new ContactForContractFactory();
